import Base from "./Base";
import Typography from "@mui/material/Typography";
import {InputAdornment, Stack, TextField, useTheme} from "@mui/material";
import {Link, useParams} from "react-router-dom";
import Button from "@mui/material/Button";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IconButton from "@mui/material/IconButton";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";


const NewPassword = () => {
    const theme = useTheme()
    const {newPassword} = useContext(AuthContext);
    const [passwordVisible, setPasswordVisible] = useState(false)
    const [data, setData] = useState({password: '', password_again: ''})
    const {slug} = useParams()

    return <Base>
        <div className="login-container">
            <div className="login-card">
                <form onSubmit={e => {
                    e.preventDefault()
                    newPassword({...data, slug: slug})
                }}>
                    <Stack spacing={{xs: 2}}>
                        <Typography variant="headline6" color={theme.palette.primary[600]}>Jelszó megváltoztatása</Typography>
                        <Stack spacing={1} marginBottom={2} marginTop={2}>
                            <input type="hidden" name='slug' value={slug}/>
                            <Typography variant="caption" color={theme.palette.primary[500]}>Új jelszó</Typography>
                            <TextField value={data?.password} onChange={e => setData({...data, password: e.target.value})} name="password" type={passwordVisible ? "text" : "password"} variant='standard' InputProps={{
                                endAdornment: <InputAdornment position="end"><IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    edge="end"
                                >
                                    {passwordVisible ? <VisibilityOffRoundedIcon /> : <RemoveRedEyeRoundedIcon />}
                                </IconButton>
                                </InputAdornment>
                            }}/>
                            <Typography variant="caption" color={theme.palette.primary[500]}>Új jelszó mégegyszer</Typography>
                            <TextField value={data?.password_again} onChange={e => setData({...data, password_again: e.target.value})} name="password_again" type={passwordVisible ? "text" : "password"} variant='standard' InputProps={{
                                endAdornment: <InputAdornment position="end"><IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    edge="end"
                                >
                                    {passwordVisible ? <VisibilityOffRoundedIcon /> : <RemoveRedEyeRoundedIcon />}
                                </IconButton>
                                </InputAdornment>
                            }}/>
                        </Stack>
                        <Button variant="contained" type="submit">Jelszó megváltoztatása</Button>
                    </Stack>
                </form>
            </div>
        </div>
    </Base>
}

export default NewPassword
